export const MIN_PUBLIC_IDENTIFIER_LENGTH = 18;

export function validPublicIdentifier(value) {
  return (
    typeof value === 'string' &&
    value.length >= MIN_PUBLIC_IDENTIFIER_LENGTH &&
    value.length <= 128 &&
    /^[A-Za-z0-9_-]+$/.test(value)
  );
}
